export function getValue(option) {
  return option.value || option.id
}

export function getTagText(option) {
  return option.label?.title || option.name || option.label
}

export function checkIsNeedToShowClearButton() {
  return false
}
